import { StrapiComponent, StrapiSingleImage } from "~/types/strapi";

export enum StrapiLinkHrefType {
  tel = "tel",
  mailto = "mailto",
}

export enum StrapiLinkTargetType {
  self = "_self",
  blank = "_blank",
  parent = "_parent",
  top = "_top",
}

export enum StrapiLinkPriorityId {
  primaryPhone = "primary-phone",
  primaryEmail = "primary-email",
}

export enum StrapiEmailLinkId {
  primaryEmail = "primary-email",
  eshopEmail = "eshop-email",
}

export interface StrapiLink extends StrapiComponent {
  before?: string | null;
  displayText: string | null;
  href?: string | null;
  hrefType?: StrapiLinkHrefType | null;
  target?: StrapiLinkTargetType;
  icon?: string | null;
  hideIconOnDesktop?: boolean;
  hideIconOnTablet?: boolean;
  hideIconOnMobile?: boolean;
  linkId?: StrapiLinkPriorityId | null;
  image?: StrapiSingleImage;
}
